export const SEARCH_ERROR_MESSAGES = {
  SYSTEM_ERROR:
    "Something went wrong; please try again and if the issue persists contact scrm@costco.com.",
} as const;
